import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';
import { SnackbarState } from 'types/snackbar/snackbar-state';

const initialState: SnackbarState = {
    open: false,
    message: '',
    severity: 'success',
    autoHideDuration: 4000,
    position: {
        vertical: 'bottom',
        horizontal: 'left',
    },
};

const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        openSnackbar: (state, action: PayloadAction<SnackbarState>) => {
            state.open = true;
            state.message = action.payload.message
                ? action.payload.message
                : initialState.message;
            state.severity = action.payload.severity
                ? action.payload.severity
                : initialState.severity;
            state.autoHideDuration = action.payload.autoHideDuration
                ? action.payload.autoHideDuration
                : initialState.autoHideDuration;
            state.position = action.payload.position
                ? action.payload.position
                : initialState.position;
        },
        closeSnackbar: (state) => {
            state.open = false;
        },
    },
});

export const { openSnackbar, closeSnackbar } = snackbarSlice.actions;

export const selectSnackbarOptions = (state: RootState) => state.snackbar;

export default snackbarSlice.reducer;
